export const PDF_HEADER = {
    pt: [
        { datakey: 'account', title: 'Empresa' },
        { datakey: 'client', title: 'Cliente' },
        { datakey: 'site', title: 'Local' },
        { datakey: 'point', title: 'Ponto' },
        { datakey: 'date', title: 'Data' },
        { datakey: 'scans', title: 'Leituras' },
    ],
    en: [
        { datakey: 'account', title: 'Account' },
        { datakey: 'client', title: 'Client' },
        { datakey: 'site', title: 'Site' },
        { datakey: 'point', title: 'Point' },
        { datakey: 'date', title: 'Date' },
        { datakey: 'scans', title: 'Scans' },
    ],
}
